import type { FunctionComponent } from 'react';

type TagProps = {
  text: string;
  variant: 'red' | 'yellow';
};

const variantStyles = {
  red: 'bg-red-100 text-red-700',
  yellow: 'bg-orange-100 text-orange-700',
};

export const Tag: FunctionComponent<TagProps> = ({ text, variant }) => {
  return (
    <span
      className={`inline-block rounded-sm border-0 px-1.5 py-0.5 text-xs font-normal ${variantStyles[variant]}`}
    >
      {text}
    </span>
  );
};
